var map = {
	"./add.svg": "c2a3",
	"./addinfo.svg": "10b4",
	"./banner_eight.svg": "d88b",
	"./banner_eight_hover.svg": "336f",
	"./banner_five.svg": "769d",
	"./banner_five_hover.svg": "6dda",
	"./banner_four.svg": "b42a",
	"./banner_four_hover.svg": "2cdd",
	"./banner_one.svg": "dccf",
	"./banner_one_hover.svg": "476f",
	"./banner_seven.svg": "fc1d",
	"./banner_seven_hover.svg": "0e3a",
	"./banner_six.svg": "a83b",
	"./banner_six_hover.svg": "97f0",
	"./banner_three.svg": "43981",
	"./banner_three_hover.svg": "92bc",
	"./banner_two.svg": "53ce",
	"./banner_two_hover.svg": "1276",
	"./close.svg": "7710",
	"./delete.svg": "59a1",
	"./dingyue.svg": "c64f",
	"./edit.svg": "aa46",
	"./fdactive.svg": "01e6",
	"./fengdian.svg": "59db",
	"./fenxi.svg": "ff89",
	"./gfactive.svg": "ec34",
	"./guangfu.svg": "5e3d",
	"./hdactive.svg": "43b1",
	"./hedactive.svg": "e585",
	"./hedian.svg": "d508",
	"./helps.svg": "c099",
	"./huodian.svg": "513f",
	"./hyfenxi.svg": "9c63",
	"./hyzz.svg": "b4cd",
	"./ic_sale.svg": "7070",
	"./icbuy.svg": "c4e1",
	"./imagefa.svg": "57cf",
	"./imagefeng.svg": "bf41",
	"./imageguang.svg": "1d9f",
	"./imagehe.svg": "0b8d",
	"./imagehui.svg": "8840",
	"./imagehuo.svg": "adb9",
	"./imageshui.svg": "48a4",
	"./kaipan.svg": "c827",
	"./market.svg": "3338",
	"./marketactive.svg": "8a12",
	"./notice.svg": "fc99",
	"./qiugou.svg": "9761",
	"./renzheng.svg": "bee2",
	"./scleft.svg": "2bd0",
	"./scright.svg": "e4ab",
	"./sdactive.svg": "d4df",
	"./shuidian.svg": "9b28",
	"./soumai.svg": "7040",
	"./swactive.svg": "cbeb",
	"./swiper_five.svg": "1c9d",
	"./swiper_five_hover.svg": "9f65",
	"./swiper_four.svg": "aab4",
	"./swiper_four_hover.svg": "b713",
	"./swiper_one.svg": "901a",
	"./swiper_one_hover.svg": "1f86",
	"./swiper_three.svg": "afd9",
	"./swiper_three_hover.svg": "acca",
	"./swiper_two.svg": "b6f6",
	"./swiper_two_hover.svg": "3a2f",
	"./tips.svg": "6878",
	"./trademore.svg": "0f58",
	"./twomore.svg": "5362",
	"./zijin.svg": "af96",
	"./znfadian.svg": "7ca2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";